import { render, staticRenderFns } from "./InstrumentNameDetail.vue?vue&type=template&id=0fd647b8"
import script from "./InstrumentNameDetail.vue?vue&type=script&lang=ts"
export * from "./InstrumentNameDetail.vue?vue&type=script&lang=ts"
import style0 from "./InstrumentNameDetail.vue?vue&type=style&index=0&id=0fd647b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports